/** The loading screen, shown while the deck is being built. */

import { type Component, createSignal, onSettled } from 'solid-js';
import { clamp } from '../../lib/math.ts';
import { booting, bootMessage, bootProgress } from '../../state/ui.ts';
import styles from './BootScreen.module.css';

/** Circumference of the progress ring, r = 52. */
const CIRCUMFERENCE = 327;
/** How long the fade-out runs before the screen leaves the layout entirely. */
const FADE_MS = 900;

export const BootScreen: Component = () => {
  const [removed, setRemoved] = createSignal(false);

  onSettled(() => {
    if (booting()) return;
    const timer = setTimeout(() => {
      setRemoved(true);
    }, FADE_MS);
    return () => {
      clearTimeout(timer);
    };
  });

  const offset = (): number => CIRCUMFERENCE * (1 - clamp(bootProgress(), 0, 1));

  return (
    <div
      class={[styles.boot, { [styles.gone as string]: !booting() }]}
      style={{ display: removed() ? 'none' : undefined }}
    >
      <div class={styles.mark}>
        <svg viewBox="0 0 120 120" width="92" height="92" aria-hidden="true">
          <circle cx="60" cy="60" r="52" fill="none" stroke="rgba(11,31,23,.12)" stroke-width="2" />
          <circle
            class={styles.ring}
            cx="60"
            cy="60"
            r="52"
            fill="none"
            stroke="#2FBF71"
            stroke-width="3"
            stroke-linecap="round"
            stroke-dasharray={String(CIRCUMFERENCE)}
            stroke-dashoffset={String(offset())}
            transform="rotate(-90 60 60)"
          />
          <circle cx="60" cy="60" r="18" fill="rgba(11,31,23,.07)" />
          <circle cx="60" cy="60" r="3.5" fill="rgba(11,31,23,.25)" />
        </svg>
      </div>
      <div class={styles.title}>Turntable</div>
      <div class={styles.sub}>{bootMessage()}</div>
    </div>
  );
};
